// Animation logic from v4.html — runs on mount, returns cleanup fn
export function initLandingAnim() {
  /* ─── Lifecycle bookkeeping ─── */
  let alive = true;
  const intervals = [];
  const timeouts = [];
  const rafs = [];
  const observers = [];
  const listeners = []; // {el, type, fn}
  const setI = (fn, ms) => { const id = setInterval(fn, ms); intervals.push(id); return id; };
  const setT = (fn, ms) => { const id = setTimeout(fn, ms); timeouts.push(id); return id; };
  const raf = (fn) => { const id = requestAnimationFrame(fn); rafs.push(id); return id; };
  const on = (el, type, fn, opts) => {
    if (!el) return;
    el.addEventListener(type, fn, opts);
    listeners.push({ el, type, fn });
  };
  const obs = (o) => { observers.push(o); return o; };
  const $ = (id) => document.getElementById(id);

  /* REVEAL */
  const rv = obs(new IntersectionObserver(es => es.forEach(e => {
    if (e.isIntersecting) {
      const d = e.target.classList.contains('d1') ? 80 : e.target.classList.contains('d2') ? 160 : e.target.classList.contains('d3') ? 240 : 0;
      setT(() => alive && e.target.classList.add('in'), d);
      rv.unobserve(e.target);
    }
  }), { threshold: .08 }));
  document.querySelectorAll('.rv').forEach(el => rv.observe(el));

  /* HOW IT WORKS — auto-switch toutes les 5s */
  let tab = 'exp', prog = 0, timer = null;
  const TICK = 50, TOTAL = 5000;
  function switchTab(t) {
    if (!alive) return;
    const btnExp = $('btnExp'), btnTra = $('btnTra'), pe = $('panelExp'), pt = $('panelTra');
    if (!btnExp || !btnTra || !pe || !pt) return;
    tab = t;
    btnExp.classList.toggle('active', t === 'exp');
    btnTra.classList.toggle('active', t === 'tra');
    [pe, pt].forEach(p => p.style.opacity = '0');
    setT(() => {
      if (!alive) return;
      pe.classList.toggle('act', t === 'exp');
      pt.classList.toggle('act', t === 'tra');
      (t === 'exp' ? pe : pt).style.opacity = '1';
    }, 200);
    prog = 0;
  }
  function runProg() {
    if (timer) clearInterval(timer);
    timer = setI(() => {
      if (!alive) return;
      prog += TICK / TOTAL * 100;
      if (prog >= 100) switchTab(tab === 'exp' ? 'tra' : 'exp');
    }, TICK);
  }
  on($('btnExp'), 'click', () => { switchTab('exp'); runProg(); });
  on($('btnTra'), 'click', () => { switchTab('tra'); runProg(); });
  runProg();

  /* CAROUSEL */
  const ROUTES = [
    { flags: '🇫🇷→🇸🇳', corridor: 'Europe · Afrique Ouest', from: 'Paris', to: 'Dakar' },
    { flags: '🇧🇪→🇨🇮', corridor: 'Europe · Afrique Ouest', from: 'Bruxelles', to: 'Abidjan' },
    { flags: '🇺🇸→🇳🇬', corridor: 'Amérique · Afrique', from: 'New York', to: 'Lagos' },
    { flags: '🇨🇦→🇲🇦', corridor: 'Amérique · Afrique Nord', from: 'Montréal', to: 'Casablanca' },
    { flags: '🇧🇯→🇫🇷', corridor: 'Afrique · Europe', from: 'Cotonou', to: 'Marseille' },
    { flags: '🇫🇷→🇨🇲', corridor: 'Europe · Afrique Centrale', from: 'Paris', to: 'Douala' },
    { flags: '🇫🇷→🇲🇱', corridor: 'Europe · Afrique Ouest', from: 'Marseille', to: 'Bamako' },
    { flags: '🇩🇪→🇲🇦', corridor: 'Europe · Afrique Nord', from: 'Berlin', to: 'Casablanca' },
    { flags: '🇨🇦→🇸🇳', corridor: 'Amérique · Afrique', from: 'Montréal', to: 'Dakar' },
    { flags: '🇫🇷→🇨🇮', corridor: 'Europe · Afrique Ouest', from: 'Lyon', to: 'Abidjan' },
  ];
  const cTrack = $('cTrack');
  const cWrap = $('cWrap');
  let scrollX = 0, paused = false, drag = false, dragX = 0, dragS = 0;
  const CW = 220 + 12, totalW = CW * ROUTES.length;
  if (cTrack && cWrap) {
    [...ROUTES, ...ROUTES, ...ROUTES].forEach(d => {
      const c = document.createElement('div'); c.className = 'rcard';
      c.innerHTML = `<div class="rc-hd"><span class="rc-flags">${d.flags}</span></div>
      <div class="rc-rn">${d.from}<span class="rc-rarr">→</span>${d.to}</div>
      <div class="rc-corr">${d.corridor}</div>`;
      cTrack.appendChild(c);
    });
    (function tick() {
      if (!alive) return;
      if (!paused && !drag && cTrack) {
        scrollX += 0.55;
        if (scrollX >= totalW) scrollX -= totalW;
        cTrack.style.transform = `translateX(-${scrollX}px)`;
      }
      raf(tick);
    })();
    on(cWrap, 'mouseenter', () => paused = true);
    on(cWrap, 'mouseleave', () => paused = false);
    on(cWrap, 'mousedown', e => { drag = true; dragX = e.clientX; dragS = scrollX; cWrap.style.cursor = 'grabbing'; });
    on(window, 'mousemove', e => { if (!drag) return; scrollX = dragS + (dragX - e.clientX); if (scrollX < 0) scrollX += totalW; if (scrollX >= totalW) scrollX -= totalW; });
    on(window, 'mouseup', () => { drag = false; if (cWrap) cWrap.style.cursor = ''; });
    on(cWrap, 'touchstart', e => { dragX = e.touches[0].clientX; dragS = scrollX; }, { passive: true });
    on(cWrap, 'touchmove', e => { const dx = dragX - e.touches[0].clientX; scrollX = dragS + dx; if (scrollX < 0) scrollX += totalW; if (scrollX >= totalW) scrollX -= totalW; }, { passive: true });
  }

  /* AFRIQUE CANVAS */
  const canvas = $('afCanvas');
  if (canvas && canvas.getContext) {
    const ctx = canvas.getContext('2d');
    let W, H, pts = [];
    function resize() { W = canvas.width = canvas.offsetWidth; H = canvas.height = canvas.offsetHeight; }
    class P { constructor() { this.reset(); } reset() { this.x = Math.random() * W; this.y = Math.random() * H; this.r = Math.random() * 1.4 + .4; this.vx = (Math.random() - .5) * .4; this.vy = (Math.random() - .5) * .4; this.a = Math.random() * .45 + .15; } draw() { ctx.beginPath(); ctx.arc(this.x, this.y, this.r, 0, Math.PI * 2); ctx.fillStyle = `rgba(240,201,122,${this.a})`; ctx.fill(); this.x += this.vx; this.y += this.vy; if (this.x < 0 || this.x > W || this.y < 0 || this.y > H) this.reset(); } }
    function initP() { pts = Array.from({ length: 60 }, () => new P()); }
    function drawLines() { for (let i = 0; i < pts.length; i++) for (let j = i + 1; j < pts.length; j++) { const dx = pts[i].x - pts[j].x, dy = pts[i].y - pts[j].y, d = Math.sqrt(dx * dx + dy * dy); if (d < 90) { ctx.beginPath(); ctx.moveTo(pts[i].x, pts[i].y); ctx.lineTo(pts[j].x, pts[j].y); ctx.strokeStyle = `rgba(126,207,194,${.1 * (1 - d / 90)})`; ctx.lineWidth = .5; ctx.stroke(); } } }
    function renderCanvas() { if (!alive) return; ctx.clearRect(0, 0, W, H); drawLines(); pts.forEach(p => p.draw()); raf(renderCanvas); }
    const ro = obs(new ResizeObserver(() => { resize(); initP(); }));
    if (canvas.parentElement) ro.observe(canvas.parentElement);
    resize(); initP(); renderCanvas();
  }

  /* COUNTERS */
  const cntObs = obs(new IntersectionObserver(es => es.forEach(e => {
    if (e.isIntersecting) {
      const el = e.target.querySelector('.af-kv'); if (!el) return;
      const t = parseInt(e.target.dataset.cnt), s = e.target.dataset.sfx || '';
      const start = Date.now();
      (function go() { if (!alive) return; const p = Math.min((Date.now() - start) / 1400, 1), ease = 1 - Math.pow(1 - p, 3); el.textContent = Math.round(ease * t) + s; if (p < 1) raf(go); })();
      cntObs.unobserve(e.target);
    }
  }), { threshold: .4 }));
  document.querySelectorAll('[data-cnt]').forEach(el => cntObs.observe(el));

  /* ─── Cleanup fn returned to React useEffect ─── */
  return function cleanup() {
    alive = false;
    intervals.forEach(clearInterval);
    timeouts.forEach(clearTimeout);
    rafs.forEach(cancelAnimationFrame);
    observers.forEach(o => { try { o.disconnect(); } catch (_) {} });
    listeners.forEach(({ el, type, fn }) => { try { el.removeEventListener(type, fn); } catch (_) {} });
  };
}
